import {
  DispatcherCloneTaskRequest,
  Task,
} from "@quickcommerceltd/zephyr-types";
import { getCallable } from "../../helpers/getCallable";

export const cloneTaskCallable = getCallable<DispatcherCloneTaskRequest, Task>(
  "user/cloneTask"
);
